import { union } from "superstruct";

import InstagramPostLinkTagSchema from "./InstagramPostLinkTagSchema";
import InstagramPostProductTagSchema from "./InstagramPostProductTagSchema";

const InstagramPostTagSchema = union([
    InstagramPostLinkTagSchema,
    InstagramPostProductTagSchema,
]);

export default InstagramPostTagSchema;
